import React from 'react';
import tower from '../assets/Images/tower.png';
import img1 from '../assets/Images/natprevar/img_1.webp';
import img2 from '../assets/Images/natprevar/img_2.webp';
import img3 from '../assets/Images/natprevar/img_3.webp';
import img4 from '../assets/Images/natprevar/img_4.webp';
import img5 from '../assets/Images/natprevar/img_5.webp';
import img6 from '../assets/Images/natprevar/img_6.webp';
import img7 from '../assets/Images/natprevar/img_7.webp';
import img8 from '../assets/Images/natprevar/img_8.webp';
import img9 from '../assets/Images/natprevar/img_9.webp';
import img10 from '../assets/Images/natprevar/img_10.webp';
import img11 from '../assets/Images/natprevar/img_11.webp';
import img12 from '../assets/Images/natprevar/img_12.webp';
import img13 from '../assets/Images/natprevar/img_13.webp';
import img14 from '../assets/Images/natprevar/img_14.webp';

const Galerija = () => {
  // Gallery images imported from assets/Images/natprevar
  // keep original imports as fallbacks and add a `name` to generate optimized srcset URLs
  const galleryImages = [
    { id: 1, name: 'img_1', src: img1, alt: 'Слика 1' },
    { id: 2, name: 'img_2', src: img2, alt: 'Слика 2' },
    { id: 3, name: 'img_3', src: img3, alt: 'Слика 3' },
    { id: 4, name: 'img_4', src: img4, alt: 'Слика 4' },
    { id: 5, name: 'img_5', src: img5, alt: 'Слика 5' },
    { id: 6, name: 'img_6', src: img6, alt: 'Слика 6' },
    { id: 7, name: 'img_7', src: img7, alt: 'Слика 7' },
    { id: 8, name: 'img_8', src: img8, alt: 'Слика 8' },
    { id: 9, name: 'img_9', src: img9, alt: 'Слика 9' },
    { id: 10, name: 'img_10', src: img10, alt: 'Слика 10' },
    { id: 11, name: 'img_11', src: img11, alt: 'Слика 11' },
    { id: 12, name: 'img_12', src: img12, alt: 'Слика 12' },
    { id: 13, name: 'img_13', src: img13, alt: 'Слика 13' },
    { id: 14, name: 'img_14', src: img14, alt: 'Слика 14' },
  ];

  return (
    <div className="min-h-screen bg-[#E4570B] flex flex-col items-center px-5 py-10">
      {/* Header */}
      <header className="flex flex-col items-center mb-4">
        <h1 
          className="text-5xl md:text-7xl lg:text-8xl font-bold mb-3"
          style={{ 
            color: '#EFA74F', 
            fontFamily: 'Zeitmax, system-ui, sans-serif',
            letterSpacing: '2px',
            textShadow: '0 0 15px rgba(239, 167, 79, 0.7)'
          }}
        >
          Галерија
        </h1>
        <div 
          className="w-64 md:w-80 lg:w-96 h-1.5 rounded-full"
          style={{ background: 'linear-gradient(90deg, #EFA74F, #749269)' }}
        />
      </header>

      {/* Tower - show more of the body and cap max height so it doesn't get too large */}
      <div className="flex justify-center items-start w-full h-[40vh] md:h-[50vh] lg:h-[55vh] overflow-hidden mb-0">
        <img
          src={tower}
          alt="Tower"
          loading="eager"
          decoding="async"
          className="w-auto h-[120%] md:h-[130%] lg:h-[140%] max-h-[520px] md:max-h-[640px] lg:max-h-[720px] object-cover object-top"
          style={{ filter: 'drop-shadow(0 8px 20px rgba(106, 49, 10, 0.35))' }}
        />
      </div>

      {/* Gallery Timeline */}
      <div className="flex flex-col items-center w-full max-w-3xl">
        {galleryImages.map((image, index) => (
          <div key={image.id} className="flex flex-col items-center w-full">
            {/* Image Card */}
            <div 
              className="w-[90%] md:w-full max-w-2xl bg-[#6A310A] rounded-xl p-4 border-2 border-[#EFA74F] transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:border-[#DFC293]"
              style={{ boxShadow: '0 4px 12px rgba(239, 167, 79, 0.2)' }}
            >
              <picture>
                <source
                  type="image/avif"
                  srcSet={`${process.env.PUBLIC_URL}/optimized/natprevar/${image.name}-480.avif 480w, ${process.env.PUBLIC_URL}/optimized/natprevar/${image.name}-800.avif 800w, ${process.env.PUBLIC_URL}/optimized/natprevar/${image.name}-1200.avif 1200w`}
                  sizes="(max-width: 640px) 480px, (max-width: 1024px) 800px, 1200px"
                />
                <source
                  type="image/webp"
                  srcSet={`${process.env.PUBLIC_URL}/optimized/natprevar/${image.name}-480.webp 480w, ${process.env.PUBLIC_URL}/optimized/natprevar/${image.name}-800.webp 800w, ${process.env.PUBLIC_URL}/optimized/natprevar/${image.name}-1200.webp 1200w`}
                  sizes="(max-width: 640px) 480px, (max-width: 1024px) 800px, 1200px"
                />
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-64 md:h-96 rounded-lg object-cover object-center"
                />
              </picture>
            </div>
            
            {/* Connector Line */}
            {index < galleryImages.length - 1 && (
              <div className="w-[24px] md:w-[36px] lg:w-[48px] max-w-[48px] h-16 md:h-24 lg:h-28 bg-[#6A310A] rounded-sm my-0" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Galerija;
